import { render, staticRenderFns } from "./VirtualDetail.vue?vue&type=template&id=c0a5dc82&scoped=true&"
import script from "./VirtualDetail.vue?vue&type=script&lang=js&"
export * from "./VirtualDetail.vue?vue&type=script&lang=js&"
import style0 from "./VirtualDetail.vue?vue&type=style&index=0&id=c0a5dc82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a5dc82",
  null
  
)

export default component.exports